export default __webpack_public_path__ + "static/media/snapshots.4483c67a.png";